import React, { Component } from "react";
import { forgotPassword } from "../auth";

class ForgotPassword extends Component {
    state = {
        email: "",
        message: "",
        error: ""
    };

    handleChange = event => {
        const lValue = event.target.value;
        this.setState({ email: lValue, error: "", message: "" });
    }

    forgotPassword = e => {
        e.preventDefault();
        this.setState({ message: "", error: "" });
        forgotPassword(this.state.email).then(data => {
            if (data.error) {
                this.setState({ error: data.error });
            } else {
                this.setState({ message: data.message });
            }
        });
    };

    render() {
        return (
            <div className="container">
                <h2 className="mt-5">Ask for Password Reset</h2>
                <form onSubmit={this.forgotPassword}>
                    <div className="form-group mt-5">
                        <input
                            type="email"
                            className="form-control"
                            placeholder="Your email address"
                            value={this.state.email}
                            onChange={this.handleChange}
                            name="email"
                            autoFocus
                        />
                    </div>
                    <button
                        //onClick={this.forgotPassword}
                        className="btn btn-raised btn-primary"
                    >
                        Send Password Rest Link
                    </button>
                </form>
                <div className="alert alert-danger" style={{ display: this.state.error ? "block" : "none" }}>
                    {this.state.error}
                </div>
                <div className="alert alert-success" style={{ display: this.state.message ? "block" : "none" }}>
                    {this.state.message}
                </div>
               
            </div>
        );
    }
}

export default ForgotPassword;